var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkmark",
    clipPath: "url(#clip0_436_1660)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9996 31.6832C24.6611 31.6832 31.6827 24.6616 31.6827 16.0001C31.6827 7.33849 24.6611 0.316895 15.9996 0.316895C7.338 0.316895 0.316406 7.33849 0.316406 16.0001C0.316406 24.6616 7.338 31.6832 15.9996 31.6832Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9462 22.2548C13.7714 22.2548 13.5984 22.2201 13.4371 22.1524C13.2759 22.0848 13.1298 21.9858 13.0073 21.8611L8.14831 16.923C7.63871 16.4042 7.64529 15.572 8.16412 15.0611C8.68295 14.5528 9.51648 14.558 10.0261 15.0769L13.9081 19.022L21.9393 10.177C22.4304 9.63845 23.2627 9.60027 23.7986 10.0875C24.3372 10.576 24.3767 11.4082 23.8881 11.9481L14.9207 21.8241C14.8003 21.9568 14.6542 22.0636 14.4912 22.1378C14.3282 22.2121 14.1517 22.2523 13.9726 22.256C13.9634 22.2548 13.9555 22.2548 13.9462 22.2548Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_1660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.b56ab86b1dbe5400d8fae333b5025a99.svg";
export { ForwardRef as ReactComponent };